<h2>Sorry!</h2>
<p>This view is not supported on mobile. Use your desktop to enjoy the best RappiOne experience!</p>
<div class="image-container">
  <img [src]="unavailableImage" alt="Descriptive image for unable page on mobile">
</div>
